import { BaseComponentImpl } from '../../../../types/implementations';
import { Building } from '../../../../types/protocols';
import { CardinalDirection } from '../../../../types/Enums';

/**
 * Resolves the cardinal direction for a component by checking:
 * 1. The component's own cardinalDirection property
 * 2. Any parent components (parentSurface, parentSurface1, parentSurface2, parentComponentKey) for cardinal direction
 *
 * Returns the first cardinal direction found, or null if none exists.
 *
 * @param component - The component to resolve cardinal direction for
 * @param building - The building containing all components
 * @returns The resolved cardinal direction or null
 */
export function resolveCardinalDirection(
    component: BaseComponentImpl,
    building: Building | null
): CardinalDirection | null {
    // First check component's own cardinal direction
    if (component.cardinalDirection?.value) {
        return component.cardinalDirection.value;
    }

    // Check parent components if no direct cardinal direction
    if (!building?.model?.structure?.components) {
        return null;
    }

    // Collect all parent keys (could be parentSurface, parentSurface1, parentSurface2, or parentComponentKey)
    const parentKeys = [
        component.parentSurface?.value,
        component.parentSurface1?.value,
        component.parentSurface2?.value,
        component.parentComponentKey  // Plain string, not ValueWithMetadata
    ].filter(Boolean) as string[];

    // Check each parent component for cardinal direction
    for (const parentKey of parentKeys) {
        const parent = building.model.structure.components[parentKey];
        if (parent?.cardinalDirection?.value) {
            return parent.cardinalDirection.value;
        }
    }

    return null;
}

